import { render, staticRenderFns } from "./SearchDoctorInput.vue?vue&type=template&id=56120834&"
import script from "./SearchDoctorInput.vue?vue&type=script&lang=js&"
export * from "./SearchDoctorInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports